import axios from "axios";
import jwtDecode from "jwt-decode";

let accessToken;
const setAccessTokenSilently = accessTokenRef => {
	accessToken = accessTokenRef;
};

const httpService = axios.create({
	withCredentials: false
});

const call =
	method =>
	async (url, { body, headers = {}, useAuth } = {}) => {
		if (useAuth) {
			const token = await accessToken();
			if (token) {
				headers["Authorization"] = `Bearer ${token}`;
				//console.log(token);
			}
		}

		return httpService({
			method,
			url: url,
			data: body,
			headers
		})
			.then(response => {
				return {
					...response.data,
					success: true
				};
			})
			.catch(error => {
				console.log(error);
				return {
					errorData: error.response && error.response.data,
					success: false
				};
			});
	};
const Service = {
	httpService,
	get: call("GET"),
	post: call("POST"),
	put: call("PUT"),
	delete: call("DELETE")
};
export default Service;
const getUserId = async () => {
	const token = await accessToken();
	if (token) {
		const decodedToken = jwtDecode(token);
		return decodedToken["https://accounts.ikea.com/networkid"];
	}
};
export { setAccessTokenSilently, getUserId };

